const ACTIVE_SUBSCRIBERS_ROLE = "active_subscribers";
const POWURLINE_COMP_TYPE = "powurline";
const POWUR_EMAIL_DOMAIN = "@powur.com";
const AMBASSADOR_PERMISSION = "ambassador";

type PermissionT = {
  name: string;
};

export type PowurEnergyLapsedInputT = {
  permissions?: ReadonlyArray<PermissionT> | null;
  roles?: ReadonlyArray<string> | null;
  email?: string | null;
  hasSeat?: unknown;
  isOrgOwner?: unknown;
  enterpriseCompType?: string | null;
  comped?: boolean | null;
};

type SessionLikeT = {
  rbac?: {
    permissions?: ReadonlyArray<PermissionT> | null;
  } | null;
  user?: {
    props: {
      roles?: ReadonlyArray<string> | null;
      email?: string | null;
      seatId?: unknown;
      enterprise?: {
        isOwner?: unknown;
        compType?: string | null;
      } | null;
      enrollment?: {
        comped?: boolean | null;
      } | null;
    };
  } | null;
};

export const userIsPowurEnergyLapsed = (input: PowurEnergyLapsedInputT | null | undefined): boolean => {
  if (input == null) return false;

  const { permissions, roles, email, hasSeat, isOrgOwner, enterpriseCompType, comped } = input;

  if (!Array.isArray(roles)) return false;

  if (email && email.toLowerCase().endsWith(POWUR_EMAIL_DOMAIN)) return false;
  if (hasSeat) return false;
  if (isOrgOwner) return false;
  if (comped === true) return false;
  if (enterpriseCompType === POWURLINE_COMP_TYPE) return false;
  if (Array.isArray(permissions) && permissions.some((p) => p.name === AMBASSADOR_PERMISSION)) return false;

  return !roles.includes(ACTIVE_SUBSCRIBERS_ROLE);
};

export const userIsPowurEnergyLapsedFromSession = (session: SessionLikeT | null | undefined): boolean => {
  if (session == null) return false;

  return userIsPowurEnergyLapsed({
    permissions: session.rbac?.permissions,
    roles: session.user?.props.roles,
    email: session.user?.props.email,
    hasSeat: Boolean(session.user?.props.seatId),
    isOrgOwner: Boolean(session.user?.props.enterprise?.isOwner),
    enterpriseCompType: session.user?.props.enterprise?.compType,
    comped: session.user?.props.enrollment?.comped,
  });
};
